import { isAaveType, isCompoundV3 } from '@1delta/lender-registry'
import {
  aaveTokens,
  aavePools,
  aaveReserves,
  compoundV3Reserves,
} from '@1delta/data-sdk'

/** No specific configuration */
export const LENDER_MODE_NO_MODE = 0

export function getAaveStyleProtocolTokenMap(chainId: string, lender: string) {
  return aaveTokens()?.[lender]?.[chainId]
}

export const getAaveAssets = (
  chainId: string | undefined,
  lendingProtocol: string | undefined,
): string[] => {
  if (isAaveType(lendingProtocol ?? ''))
    return aaveReserves()?.[lendingProtocol ?? '']?.[chainId ?? ''] ?? []
  return []
}

export const getCompoundV3Assets = (
  chainId: string | undefined,
  lendingProtocol: string | undefined,
): string[] => {
  if (isCompoundV3(lendingProtocol ?? ''))
    return compoundV3Reserves()?.[lendingProtocol ?? '']?.[chainId ?? '']
  return []
}

export function getAaveTypePoolDataProviderAddress(
  chainId: string,
  lender: string,
) {
  // @ts-ignore
  return aavePools()?.[lender]?.[chainId]?.protocolDataProvider
}

/**
 * Highest ACTIVE e-mode category id for this deployment, probed on-chain by the
 * `lender-metadata` daily run. `undefined` when the metadata predates the field
 * (or the probe failed) — callers must fall back, never treat it as 0.
 */
export function getAaveTypeEModeCount(
  chainId: string,
  lender: string,
): number | undefined {
  // @ts-ignore
  const count = aavePools()?.[lender]?.[chainId]?.eModeCount
  return typeof count === 'number' && Number.isFinite(count) && count >= 0
    ? count
    : undefined
}

export function getAaveTypePoolAddress(
  chainId: string,
  lender: string,
): string {
  // @ts-ignore
  return aavePools()?.[lender]?.[chainId]?.pool
}

/**
 * Convert a string (asset symbol) to a Supported asset, considering also naming conflicts
 * @param a string
 * @returns SupportedAsset
 */
export const toOracleKey = (a: string | null) => {
  return a ?? ''
}

export const toGenericPriceKey = (
  assetAddress: string | null,
  chainId: string,
) => {
  return chainId + '-' + assetAddress
}
